/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M9 20c-1.629 0-3 1.371-3 3v54c0 1.629 1.371 3 3 3h82c1.629 0 3-1.371 3-3V23c0-1.629-1.371-3-3-3zm3.094 4h75.812L50 58.281zM10 27.5l23.406 21.156L10 72.937zm80 0v45.438L66.594 48.657zM36.375 51.344l12.281 11.125a2 2 0 002.688 0l12.28-11.125L87.405 76H12.593z"/>'
  }
})
